import type { FC } from 'react';
import { useState } from 'react';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';

import { noDataAvailableStyles } from 'src/theme/sharedStyles';

interface BarSegmentProps {
  type: 'vertical' | 'horizontal';
  label?: string;
  relativeSize: number;
  borderPosition: 'Right' | 'Left' | 'Top' | 'Bottom';
  color: string;
  borderColor: string;
  toolTip?: string;
  withGradient?: boolean;
  borderWidth?: number;
  noDataAvailable?: boolean;
}

const BarSegment: FC<BarSegmentProps> = ({
  color,
  withGradient,
  borderPosition,
  borderWidth,
  borderColor,
  label,
  relativeSize,
  type,
  toolTip,
  noDataAvailable,
}) => {
  const theme = useTheme();
  const barStyles = {
    background: withGradient
      ? `linear-gradient(180deg, ${color}1a 57.08%, ${color}01 161.01%);`
      : color,
    [`border${borderPosition}`]: `solid ${borderWidth}px ${borderColor}`,
    minHeight: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    ...(noDataAvailable && {
      ...noDataAvailableStyles.noDataAvailable(theme),
      borderColor: 'transparent',
    }),
  };
  const [showToolTip, setShowToolTip] = useState(false);
  return (
    <Box
      sx={barStyles}
      height={type === 'vertical' ? `${relativeSize}%` : '100%'}
      width={type === 'horizontal' ? `${relativeSize}%` : '100%'}
      onMouseEnter={() => setShowToolTip(true)}
      onMouseLeave={() => setShowToolTip(false)}
    >
      <Tooltip title={toolTip} placement={'bottom'} open={showToolTip}>
        <Typography variant="caption" color={borderColor}>
          {label}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default BarSegment;
